import React, { useState, useRef } from "react";
import { useEffect } from "react";
import { addSetDataFormConfig } from "../addSetData.formfields.config";
import FormCreator from "../../../../../../components/forms/FormCreator";
import Buttons from "../../../../../../components/ui/button/Buttons";
import { useLazyGetAllReportTemplateByValidQuery } from "../../../../../../app/services/reportTemplateAPI";
import { mapDropdownOptions } from "../../../../../../components/forms/libs/data/mapDropdownOptions";
import { useAddSetMutation } from "../../../../../../app/services/clientValuationAPI";
import ToastService from "../../../../../../services/toastService/ToastService";
import PropTypes from "prop-types";

const AddSetData = (props) => {
  const clientRef = useRef()

  const [formData, setFormData] = useState(
    addSetDataFormConfig
  );

  const [getAllReportTemplateList, {
    isFetching: isAllReportTemplateFetching,
    isSuccess: isAllReportTemplateSuccess,
    data: AllReportTemplateData
  },] = useLazyGetAllReportTemplateByValidQuery();

  const [addSet, {
    isLoading: isSetAdding,
    isSuccess: isSetAdded,
    data: setAddedData
  }] = useAddSetMutation()

  useEffect(() => {
    getAllReportTemplateList(props?.valID);
  }, [])

  const handleAddClick = () => {
    const formData = clientRef.current.getFormData();
    if (formData) {
      const req = {
        reportTemplateID:formData.reportTemplateID.value,
        valID:props.valID
      }
      addSet(req);
    }
  };

  useEffect(() => {
    if (isSetAdded && setAddedData) {
      if (setAddedData?.errorMessage?.includes('exist')) {
        ToastService.warning(setAddedData.errorMessage);
      } else {
        ToastService.success(setAddedData.errorMessage);
        props.onSuccess?.();
      }
    }
  }, [isSetAdded, setAddedData]);

  useEffect(() => {
    if (!isAllReportTemplateFetching && isAllReportTemplateSuccess && AllReportTemplateData) {
      const form = { ...formData }
      mapDropdownOptions(
        form,
        'basicDetailSection',
        'reportTemplateID',
        AllReportTemplateData,
        'reportTemplateID',
        'reportTemplateName'
      )
      setFormData(form);
    }
  }, [isAllReportTemplateFetching, isAllReportTemplateSuccess, AllReportTemplateData]);

  const handleCloseClick = () => {
    props?.onClose();
  };

  return (
    <>
      <div className="top-filter-sec">
        <FormCreator ref={clientRef} config={formData} />

        <div className="col-12">
          <div className="form-button-group">
            <Buttons
              buttonText="Cancel"
              buttonTypeClassName="btn secondary-btn"
              onClick={handleCloseClick}
            />
            <Buttons
              buttonText={"Add"}
              buttonTypeClassName="btn blue-btn w-full"
              onClick={handleAddClick}
              isLoading={isSetAdding}
            />
          </div>
        </div>
      </div></>
  );
};

AddSetData.propTypes = {
  valID: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func
};

export default AddSetData;
